import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import withMobileDialog from "material-ui/Dialog/withMobileDialog";
import {
    Dialog,
    DialogActions,
    DialogContent,
    Button,
    TextField,
    DialogTitle,
    Typography,
    Checkbox,
    FormControlLabel
} from "material-ui";
import {
    closeProfile,
    editProfile,
    saveProfile
} from "../actions/editProfile.actions";
import LanguageMultiSelect from "../components/LanguageMultiSelect";
import { red } from "material-ui/colors/index";

const styleSheet = theme => ({
    textField: {
        width: 300,
        marginRight: theme.spacing.unit
    },
    question: {
        position: "relative"
    },
    error: {
        color: red[500],
        marginTop: -2
    },
    emailNotifications: {
        marginBottom: theme.spacing.unit
    }
});

class EditProfileDialog extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        open: PropTypes.bool.isRequired,
        displayName: PropTypes.string.isRequired,
        languages: PropTypes.object.isRequired,
        fullScreen: PropTypes.bool.isRequired,
        editProfileRequest: PropTypes.object.isRequired,
        emailNotifications: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired
    };

    handleChangeDisplayName = event => {
        this.props.dispatch(editProfile({ displayName: event.target.value }));
    };

    handleSelectedLanguagesChanged = languages => {
        this.props.dispatch(editProfile({ languages }));
    };

    handleEmailNotificationsChange = ({
        target: { checked: emailNotifications }
    }) => {
        this.props.dispatch(editProfile({ emailNotifications }));
    };

    renderDialogContent() {
        const { classes, languages, t } = this.props;
        return (
            <DialogContent>
                <TextField
                    className={classes.textField}
                    label={t("editProfileDialog.Display name")}
                    value={this.props.displayName}
                    onChange={this.handleChangeDisplayName}
                    margin="normal"
                />
                <div className={classes.emailNotifications}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.props.emailNotifications}
                                onChange={this.handleEmailNotificationsChange}
                            />
                        }
                        label={t("editProfileDialog.Send email notifications")}
                    />
                </div>
                <div>
                    <Typography
                        className={classes.question}
                        type="body1"
                        component="div">
                        {t(
                            "editProfileDialog.What language or languages do you know well?"
                        )}
                    </Typography>
                    <LanguageMultiSelect
                        selectedLanguages={languages}
                        onChange={this.handleSelectedLanguagesChanged}
                        isLearning={false}
                    />
                </div>
                <div>
                    <Typography
                        className={classes.question}
                        type="body1"
                        component="div">
                        {t(
                            "editProfileDialog.What language(s) do you want to practice?"
                        )}
                    </Typography>
                    <LanguageMultiSelect
                        selectedLanguages={languages}
                        onChange={this.handleSelectedLanguagesChanged}
                        isLearning={true}
                    />
                </div>
            </DialogContent>
        );
    }

    handleRequestClose = () => {
        this.props.dispatch(closeProfile());
    };

    submitProfile = () => {
        this.props.dispatch(saveProfile());
    };

    validateLanguages = () => {
        const { languages, t } = this.props;

        let error;
        if (!languages.find(l => l.isLearning)) {
            error = t(
                "editProfileDialog.You must have at least one language to practice"
            );
        } else if (!languages.find(l => !l.isLearning)) {
            error = t(
                "editProfileDialog.You must have at least one language you know"
            );
        }

        return { valid: !error, error };
    };

    renderDialogActions() {
        const { editProfileRequest: { requesting }, t, classes } = this.props;
        const { error, valid } = this.validateLanguages();
        return (
            <DialogActions>
                {error &&
                    <Typography className={classes.error} type="body1">
                        {error}
                    </Typography>}
                <Button onClick={this.handleRequestClose}>
                    {t("editProfileDialog.Close")}
                </Button>
                <Button
                    onClick={this.submitProfile}
                    disabled={!valid || requesting}>
                    {t("editProfileDialog.Submit")}
                </Button>
            </DialogActions>
        );
    }

    render() {
        const { fullScreen, open, t } = this.props;
        return (
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                open={open}
                onClose={this.handleRequestClose}>
                <DialogTitle>
                    {t("editProfileDialog.Edit profile")}
                </DialogTitle>
                {this.renderDialogContent()}
                {this.renderDialogActions()}
            </Dialog>
        );
    }
}

function mapStateToProps({
    editProfile: {
        open,
        displayName,
        languages,
        editProfileRequest,
        emailNotifications
    }
}) {
    return {
        open,
        displayName,
        languages,
        emailNotifications,
        editProfileRequest
    };
}

export default withMobileDialog({ breakpoint: "xs" })(
    wrapComponent(EditProfileDialog, styleSheet, mapStateToProps)
);



// WEBPACK FOOTER //
// ./src/containers/EditProfileDialog.jsx